import React from "react";

import { HomePage } from "pages/Home";

import { Routes, Route } from "react-router-dom";

import { ROUTER } from "shared/constants/router";
import { DesqualifiedPage } from "pages/Descredenciados";

const Routers: React.FC = () => {
  return (
    <Routes>
      <Route path={ROUTER.HOME} element={<HomePage />} />
      <Route path={ROUTER.DISQUALIFIED} element={<DesqualifiedPage />} />
    </Routes>
  );
};

export default Routers;
